// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

// Lazy-loaded Component
const TeamMemberPerformanceDashboard = lazy(
  () => import('pages/teamMemberPerformance/TeamMemberPerformance')
);

const TeamMemberPerformanceRoute = (
  <Route
    path={routeName.teamMemberPerformance}
    element={
      <PrivateRoute name={resourceName.profile}>
        <Suspense fallback={<Loading />}>
          <TeamMemberPerformanceDashboard />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default TeamMemberPerformanceRoute;
